<div class="hidden md:flex z-[1] fixed top-0 left-0 overflow-hidden h-screen w-screen self-center"><img
    class="min-h-[100vh] min-w-[100vw]" style="object-fit: cover;" src="../../assets/login_background.png"></div>
<div class="w-screen h-screen flex place-content-center overflow-x-hidden items-center absolute top-0 left-0 z-[2] bg-tertiary cut-bg"
*transloco="let t;prefix:'auth'">
<div class="max-h-screen md:w-[350px]">
    <div title class="text-[48px] pt-[20px] font-bold text-center mx-[18px] text-primary italic">
        <img class="mx-auto my-4" [src]="'../assets/logo.png'" />
    </div>
    <div class="px-[25px]">
        <div class="md:flex flex-wrap gap-[20px] place-content-center">

            <std-input customInputClass="custom-input" customLabel="label-input" [placeholder]="t('name') + '*'"
                customContainerlass="!w-full md:!w-[300px] border-b-[2px] border-primary mb-8"
                customInputClass="border-0 rounded-none" [(ngModel)]="credentials.firstName"
                [value]="credentials.firstName" id="name-login">
            </std-input>
            <std-input customInputClass="custom-input" customLabel="label-input" [placeholder]="t('lastName')+ '*'"
                customContainerlass="!w-full md:!w-[300px] border-b-[2px] border-primary mb-8"
                customInputClass="border-0 rounded-none" [(ngModel)]="credentials.lastName"
                [value]="credentials.lastName" id="lastName-login"></std-input>
            <std-input customInputClass="custom-input" customLabel="label-input" [placeholder]="t('email')+ '*'"
                customContainerlass="!w-full md:!w-[300px] border-b-[2px] border-primary mb-8"
                customInputClass="border-0 rounded-none" [(ngModel)]="credentials.email" [value]="credentials.email"
                id="email-login" type="email">
            </std-input>
            <std-input customInputClass="custom-input" customLabel="label-input" [placeholder]="t('password')+ '*'"
                customContainerlass="!w-full md:!w-[300px] border-b-[2px] border-primary mb-8"
                customInputClass="border-0" [(ngModel)]="credentials.password" id="password-login"
                [type]="showPassword ? 'text':'password'" [value]="credentials.password">
                <div iconRight class="flex place-content-center">
                    <img (mousedown)="showPassword = true" (mouseup)="showPassword=false" class="cursor-pointer"
                        src="../../assets/eye.svg">
                </div>
            </std-input>
            <std-input customInputClass="custom-input" customLabel="label-input" [placeholder]="t('confirmPassword')+ '*'"
                customContainerlass="!w-full md:!w-[300px] border-b-[2px] border-primary mb-8"
                customInputClass="border-0" [(ngModel)]="credentials.confirmPassword" id="confirm-password-login"
                [type]="showPassword ? 'text':'password'" [value]="credentials.confirmPassword">
                <div iconRight class="flex place-content-center">
                    <img (mousedown)="showPassword = true" (mouseup)="showPassword=false" class="cursor-pointer"
                        src="../../assets/eye.svg">
                </div>
            </std-input>
            <!-- <std-input customInputClass="custom-input" customLabel="label-input" [placeholder]="t('referral')"
                customContainerlass="!w-full md:!w-[300px] border-b-[2px] border-primary"
                customInputClass="border-0 rounded-none" [(ngModel)]="credentials.referral" [value]="credentials.referral"
                id="referral" type="text">
            </std-input> -->
            <div class="flex gap-4 text-medium items-center w-full"><std-checkbox borderTrue="var(--primary)" backGroundTrue="var(--primary)" [isChecked]="acceptTerms" (onChange)="checkboxTerms($event)" id="referral">
                </std-checkbox>
                <div>Prima di proseguire devi accettare i nostri <a class="font-bold text-primary underline" target="_blank" href="https://www.stdoutsrl.it/privacy-estetistapp/">termini e condizioni</a></div>
            </div>
            
        </div>




    </div>
    <div class="mx-auto w-[350px] pb-32">
        <div (click)="backToLogin()"
            class="text-[#2D2D2D] cursor-pointer w-fit text-[12px] opacity-50 mt-[10px] ml-auto">
            {{t('backToLogin')}}</div>
        <div class="ml-auto w-full mt-5">
            <std-button (click)=" checkCredentials()&& acceptTerms ? register() : showMessage('error',t('wrongCredentials'))"
                id="button-login" size="sm"
                buttonClass="uppercase bg-primary hover:bg-primary focus:bg-primary">{{t('register')}}</std-button>
        </div>
    </div>
</div>